import React from 'react';
import RealEstateManagingPartnerCommunications from './RealEstateManagingPartnerCommunications';

// Simplified Communications - Always renders the Real Estate Managing Partner Communications
const Communications = () => {
  return <RealEstateManagingPartnerCommunications />;
};

export default Communications;
